import { getGiftListRoute } from './gift-list-routes'

export function getLinkFromRoute(to, wedSiteInfo) {
  let result = {
    type: null, // route | link-wedsite | link-legacy
    dest: null,
  }

  const giftListRoute = getGiftListRoute(to, wedSiteInfo)

  if (!giftListRoute) {
    switch (to) {
      case 'site-home':
      case 'site-home-from-logo':
        result.type = 'link-wedsite'
        result.dest = ''
        break
      case 'shopping':
        result.type = 'route'
        result.dest = '/carteira?go=shopping'
        break
      case 'wallet':
        result.type = 'route'
        result.dest = '/carteira'
        break
      case 'logout':
        result.type = 'link-legacy'
        result.dest = '/logon/sair'
        break
      case 'preview-site':
        result.type = 'link-wedsite'
        result.dest = `?preview_as_guest=1&_ref_=${window.location.href}`
        break
      case 'wedsite-data':
      case 'wedsite-data-from-icon':
        result.type = 'link-wedsite'
        result.dest = '#/admin/dados-casamento'
        break
      case 'couple-data':
        result.type = 'link-wedsite'
        result.dest = '#/admin/dados-casal'
        break
      case 'config-domain':
        result.type = 'route'
        result.dest = '/dominio'
        break
      case 'themes':
        result.type = 'link-wedsite'
        result.dest = '#/admin/tema'
        break
      case 'customize-theme':
        if (wedSiteInfo.site_customizacao_versao) {
          result.type = 'route'
          result.dest = '/customizacao-do-tema'
        } else {
          result.type = 'link-wedsite'
          result.dest = '#/admin/customizar'
        }
        break
      case 'intro':
        result.type = 'link-wedsite'
        result.dest = '#/admin/intro'
        break
      case 'pages':
        result.type = 'link-wedsite'
        result.dest = '#/admin/abas'
        break
      case 'music':
        result.type = 'link-wedsite'
        result.dest = '#/admin/musica'
        break
      case 'messages':
        result.type = 'link-wedsite'
        result.dest = '#/admin/recados'
        break
      case 'edit-rsvp':
        if (wedSiteInfo.shared_menu.rsvp_target == 'assessoriavip') {
          result.type = 'route'
          result.dest = '/rsvp-assessoria'
        } else {
          result.type = 'route'
          result.dest = '/rsvp'
        }
        break
      case 'stationary-invites':
        result.type = 'route'
        result.dest = '/convites/oficial/'
        break
      case 'stationary-savethedate':
        result.type = 'route'
        result.dest = '/convites/save-the-date/'
        break
      case 'stationary-message':
        result.type = 'route'
        result.dest = '/convites/comunicado/'
        break
      case 'my-services':
        result.type = 'link-wedsite'
        result.dest = '#/admin/plano'
        break
      case 'rsvp':
      case 'recados':
      case 'presentes':
        result.type = 'link-wedsite'
        result.dest = '#/' + to
        break
      default:
        result.type = 'link-wedsite'
        if (
          wedSiteInfo.hasOwnProperty('site_tema_opcoes') &&
          wedSiteInfo.site_tema_opcoes.hasOwnProperty('one_page_layout') &&
          wedSiteInfo.site_tema_opcoes.one_page_layout
        ) {
          result.dest = '#/one-page/' + to
        } else {
          result.dest = '#/pagina/' + to
        }
    }
  } else {
    result = giftListRoute
  }

  return result
}

// get global or sidebar active menu (based ou url path)
export function getActiveMenu(path) {
  if (path.substring(0, 9) == '/carteira') {
    return {
      type: 'global',
      item: 'wallet',
    }
  }

  if (path.substring(0, 20) == 'customizacao-do-tema') {
    return {
      type: 'sidebar',
      item: 'appearance',
    }
  }

  if (path.substring(0, 5) == '/rsvp') {
    return {
      type: 'sidebar',
      item: 'guests',
    }
  }

  if (path.substring(0, 9) == '/convites') {
    return {
      type: 'sidebar',
      item: 'invites',
    }
  }

  return null
}
